import mutations from './mutations';
import actions from './actions';
import getters from './getters';

export default {
    namespaced: true,
    state: {
        mode: '',
        keyword: '',
        types: [],
        availableFacets: {},
        availableTypes: [],
        appliedFacets: [],
        showSaved: false,
        results: [],
        totalResults: '',
        currentPage: 1,
        totalPages: 1,
        isLoading: true,
        isSearching: false,
        searchError: null,
    },
    mutations,
    actions,
    getters,
};
